import React, { FC } from 'react';
import { RcLink } from '@ringcentral/juno';
import { ExternalLink } from '@ringcentral/juno-icon';
import { googleAnalytics, mixpanel, safeWindowOpen } from '@/core';
import { platformTypeToAppType } from '@/core/application.service';
import { rootStore } from '@/stores';
import { IProcessedProfile } from '../../typings';
import { ButtonWrapper, StyledIcon, StyledText } from './GetSupport.sc';

const trackGetSupportClick = (profile: IProcessedProfile) => {
  const brand = rootStore.compatibilitiesStore.getCompatibilityById(
    profile.brand,
  );

  const properties = {
    appId: profile.appId || '',
    profileId: profile._id,
    profileName: profile.appName,
    brandPartner: brand?.name || '',
    appName: profile.applicationName || '',
    appDisplayName: profile.applicationDisplayName || '',
    appType: platformTypeToAppType(profile.applicationType) || '',
  };

  mixpanel.trackGetSupportClicked(properties);
  googleAnalytics.trackGetSupportClicked(properties);
};

const getSupport = (profile: IProcessedProfile) => {
  safeWindowOpen(profile.supporterLink);
  trackGetSupportClick(profile);
};

export const GetSupport: FC<{ profile: IProcessedProfile }> = ({
  profile,
}: {
  profile: IProcessedProfile;
}) => {
  const colorTheme = 'secondary';
  return (
    <ButtonWrapper
      variant="plain"
      onClick={() => getSupport(profile)}
      data-test-automation-id={`get-support-wrapper`}
    >
      <StyledText>
        <RcLink color={colorTheme} data-test-automation-id={`get-support-link`}>
          Get support
        </RcLink>
      </StyledText>
      <StyledIcon
        color={['text', colorTheme]}
        symbol={ExternalLink}
        size="small"
        data-test-automation-id={`get-support-icon`}
      />
    </ButtonWrapper>
  );
};
